// src/components/CompanyLogosSlider.jsx
import React, { useState, useRef } from 'react';
import styles from './CompanyLogosSlider.module.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// Import your company logos here
// Make sure you have these images in your src/assets folder

import mphasisLogo from '../../assets/logos/MPHASIS.NS_BIG.png';
import iinfotechLogo from '../../assets/logos/3I-infotech-logo-109-x-100.png';
import amazonLogo from '../../assets/logos/amazon.png';
import cognizantLogo from '../../assets/logos/Cognizant_logo_PNG_(5).png';
import hclLogo from '../../assets/logos/hcl.png';
import tataLogo from '../../assets/logos/Tata_Logo.svg';
import wiproLogo from '../../assets/logos/Wipro_Logo.png';
import adityaBirlaLogo from '../../assets/logos/aditya-birla-group-seeklogo.svg';
import fiservLogo from '../../assets/logos/fiserv-logo-orange-ff6600.svg';
import citiBankLogo from '../../assets/logos/logo-citi-bank-transparent-PNG.png';
import pngegg1Logo from '../../assets/logos/pngegg (1).png';
import pngeggLogo from '../../assets/logos/pngegg.png';
import cssLogo from '../../assets/logos/pngfind.com-css-logo-png-6835750.png';
import pngwing1Logo from '../../assets/logos/pngwing.com (1).png';
import pngwingLogo from '../../assets/logos/pngwing.com.png';
import prophoenixLogo from '../../assets/logos/prophoenix.png';
import temenosLogo from '../../assets/logos/temenos.png';


const CompanyLogosSlider = () => {
  const sliderRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const scrollStep = 300; 

  const companyLogos = [
    { id: 1, src: mphasisLogo, alt: 'Mphasis' },
    { id: 2, src: iinfotechLogo, alt: '3I Infotech' },
    { id: 3, src: amazonLogo, alt: 'Amazon' },
    { id: 4, src: cognizantLogo, alt: 'Cognizant' },
    { id: 5, src: hclLogo, alt: 'HCL' },
    { id: 6, src: tataLogo, alt: 'Tata' },
    { id: 7, src: wiproLogo, alt: 'Wipro' },
    { id: 8, src: adityaBirlaLogo, alt: 'Aditya Birla Group' },
    { id: 9, src: fiservLogo, alt: 'Fiserv' },
    { id: 10, src: citiBankLogo, alt: 'Citi Bank' },
    { id: 11, src: pngegg1Logo, alt: 'PNGEgg 1' },
    { id: 12, src: pngeggLogo, alt: 'PNGEgg' },
    { id: 13, src: cssLogo, alt: 'CSS' },
    { id: 14, src: pngwing1Logo, alt: 'PNGWing 1' },
    { id: 15, src: pngwingLogo, alt: 'PNGWing' },
    { id: 16, src: prophoenixLogo, alt: 'ProPhoenix' },
    { id: 17, src: temenosLogo, alt: 'Temenos' },
  ];

  const handleScrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -scrollStep, behavior: 'smooth' });
    }
  };

  const handleScrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: scrollStep, behavior: 'smooth' });
    }
  };

  return (
    <section className={styles.companyLogosSection}>
      <h2 className={styles.sectionHeading}>Our Learners Work At</h2>
      <div className={styles.sliderWrapper}>
        <button onClick={handleScrollLeft} className={`${styles.scrollButton} ${styles.left}`}>
          <FaChevronLeft />
        </button>
        <div 
          className={`${styles.sliderContainer} ${isHovered ? styles.paused : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          ref={sliderRef}
        >
          <div className={styles.logoTrack}>
            {companyLogos.map((logo) => (
              <div key={logo.id} className={styles.logoItem}>
                <img src={logo.src} alt={logo.alt} />
              </div>
            ))}
          </div>
          <div className={styles.logoTrack}>
            {companyLogos.map((logo) => (
              <div key={`dup-${logo.id}`} className={styles.logoItem}>
                <img src={logo.src} alt={logo.alt} />
              </div>
            ))}
          </div>
        </div>
        <button onClick={handleScrollRight} className={`${styles.scrollButton} ${styles.right}`}>
          <FaChevronRight />
        </button>
      </div>
    </section>
  );
};

export default CompanyLogosSlider;